import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { throwError, observable, of } from "rxjs";
import { catchError, retry } from "rxjs/operators";

import { environment } from '../../../environments/environment';
import { Subject, Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from "../../app.config";

@Injectable()
export class RicercaService {
    constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {

    }

    //esempio subscription
    private finishList = new Subject<any>();
    finishList$ = this.finishList.asObservable();


    listaAziendeOte = new Array<any>();

    setListaAziendeOteSessione(listInput: Array<any>) {
        this.listaAziendeOte = listInput;
        this.finishList.next();

    }




    getListaAziendeOteSessione() {
        return this.listaAziendeOte;
    }
    //fine esempio subscription


    getCronologia(utente = null) {
        let uri = `${environment.apiEndPoint}getCronologia?username=${utente}`;

        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
        // const error = new HttpErrorResponse({ status: 500,error:{text:'errore'} });
        // return of(error) as any;
    }

    ricercaCc(cuaa = null) {
        let uri = `${environment.apiEndPoint}getCC?cuaa=${cuaa}`;

        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    ricercaSchedeVali(cuaa = null) {
        let uri = `${environment.apiEndPoint}getSchedeVali?cuaa=${cuaa}`;
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    ricercaUsosuolo(idPcgVers = null) {
        let uri = this.config.endpointGrowApp + `/getUsoSuolo?idPcgVers=${idPcgVers}`;

        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    ricercaCorpoAziendale(page: any, idPcgVers = null) {
        let uri = `${environment.apiEndPoint}getCorpoAziendale?idPcgVers=${idPcgVers}`;
        if (page) {
            uri += `&page=${(page.pageNumber)}&limit=${page.size}`;
        }
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    ricercaIsoleFiltered(page: any, idPcgVersSelezionato = null, idTavc = null, codiceIsola = null) {
        let uri = `${environment.apiEndPoint}getIsoleFiltered?idPcgVers=${idPcgVersSelezionato}&idTavc=${idTavc}&filtro=${codiceIsola}`;
        if (page) {
            uri += `&page=${(page.pageNumber)}&limit=${page.size}`;
        }
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getExtent(layers = null) {
        let uri = this.config.endpointGrowApp + `/getExtent`;
        //uri = `${environment.apiEndPoint}getExtent?layers=ciao`;
        return this.http.post(uri, layers, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }


    getPuntiCluster(layers = null) {
        let uri = this.config.endpointGrowApp + `/getPuntiCluster`;
        return this.http.post(uri, layers, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getCoordinate(layers = null) {
        let uri = `${environment.apiEndPoint}getMultipolygon`;
        return this.http.post(uri, layers, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    prelevaCuaa(idIsol = null) {
        let uri = `${environment.apiEndPoint}prelevaCuaa?idIsol=${idIsol}`;

        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getCensimentoAziende(cuaa: any) {
        let uri = `${environment.apiEndPoint}getAziendeCensite?cuaa=${cuaa}`;
        // let uri="http://localhost:8082/grow/getAziendeCensite?cuaa=" + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    eliminaAziendaCensita(idUser: any, cuaa: any) {
        let uri = `${environment.apiEndPoint}eliminaAziendaCensita?idUser=${idUser}&cuaa=${cuaa}`;
        //  let uri="http://localhost:8082/grow/eliminaAziendaCensita?idUser=" + idUser + "&cuaa=" + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    cercaAziendaUser(idUser: any, cuaa: any) {
        let uri = `${environment.apiEndPoint}cercaAziendaUser?idUser=${idUser}&cuaa=${cuaa}`;
        // let uri = "http://localhost:8082/grow/cercaAziendaUser?idUser=" + idUser + "&cuaa="  + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getRegioni() {
        let uri = `${environment.apiEndPoint}getRegioni`;
        //  let uri= `http://localhost:8082/grow/getRegioni`
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getProvince(codiRegi) {
        let uri = `${environment.apiEndPoint}getProvince?codiRegi=${codiRegi}`
        //let uri= `http://localhost:8082/grow/getProvince?codiRegi=${codiRegi}`
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getComuni(codiProv) {
        let uri = `${environment.apiEndPoint}getComuni?codiProv=${codiProv}`
        // let uri= `http://localhost:8082/grow/getComuni?codiProv=${codiProv}`
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }


    generaPdf(formInfo?: any) {
        let uri = `${environment.apiEndPoint}generapdf`;
        //let uri = "http://localhost:8087/generapdf";
        return this.http.post(uri, formInfo, { observe: 'response', responseType: 'arraybuffer' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    visualizzaConsensi(idUser: any) {
        let uri = `${environment.apiEndPoint}visualizzaConsensi?idUser=${idUser}`
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    estraiConsensiGdpr(idUser: any) {

        let uri = `${environment.apiEndPoint}estraiconsensigdpr?idUser=${idUser}`;
        //let uri="http://localhost:8087/estraiconsensigdpr?idUser=" + idUser;

        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    eliminaConsensoGdpr(idUser: any) {

        let uri = `${environment.apiEndPoint}eliminaconsensogdpr?idUser=${idUser}`;
        // let uri="http://localhost:8087/eliminaconsensogdpr?idUser=" + idUser;

        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getRuoliFiliera() {
        let uri = `${environment.apiEndPoint}getRuoliFiliera`;
        // let uri="http://localhost:8082/grow/getRuoliFiliera";
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getPosizioniIncarichi() {
        let uri = `${environment.apiEndPoint}getPosizioniIncarichi`;
        //let uri="http://localhost:8082/grow/getPosizioniIncarichi";
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    getConsorzi() {
        let uri = `${environment.apiEndPoint}getConsorzi`;
        return this.http.get(uri, { observe: 'response' }).pipe(
            retry(3),
            catchError(this.onError)
        );
    }

    inserisciDatiAziendaCensita(aziendaCensita: any) {
        let uri = `${environment.apiEndPoint}inserisciDatiAziendaCensita`;
        let body = aziendaCensita;
        return this.http.post(uri, body, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getDatiFormGdprUtente(idUtente) {
        let uri = `${environment.apiEndPoint}getDatiFormGdprUtente?idUtente=` + idUtente;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getAziendeCooperativeAssociate(cuaa) {
        let uri = `${environment.apiEndPoint}getCooperativeAssociate?cuaa=` + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getAnagraficaRapprTitolare(idUtente, cuaa) {
        let uri = `${environment.apiEndPoint}getAnagraficaRapprTitolare?idUtente=` + idUtente + "&cuaa=" + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    setDelegaCooperative(isDelega, idUtente, cuaa) {
        let uri = `${environment.apiEndPoint}setDelegaCooperative?idUtente=` + idUtente + '&isDelega=' + isDelega + '&cuaa=' + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getNumeroCooperativeAssociate(cuaa) {
        let uri = `${environment.apiEndPoint}getNumeroCooperativeAssociate?cuaa=` + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getFiliereConsorzio(codiceFiscale) {
        let uri = `${environment.apiEndPoint}getFiliereConsorzio?codiceFiscale=` + codiceFiscale;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getCooperativeAssociateProdotto(prodottoFiliera) {
        let uri = `${environment.apiEndPoint}getCooperativeAssociateProdotto?prodFili=` + prodottoFiliera;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    eliminaCooperativa(idCooperativa) {
        let uri = `${environment.apiEndPoint}eliminaCooperativa?idCooperativa=` + idCooperativa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getCooperativa(cuaa) {
        let uri = `${environment.apiEndPoint}getCooperativa?cuaa=` + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    updateRagioneSocialeCooperativa(newRagioneSociale, idCooperativa) {
        let uri = `${environment.apiEndPoint}updateRagioneSocialeCooperativa?newRagSoc=` + newRagioneSociale + '&idCooperativa=' + idCooperativa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    inserisciCooperativa(cooperativa, isCooperativaNew) {
        let uri = `${environment.apiEndPoint}inserisciCooperativa`;
        let body = {
            idCooperativa: cooperativa.idCooperativa,
            prodFili: cooperativa.prodFili,
            cuaa: cooperativa.cuaa,
            cuaaCa: cooperativa.cuaaCa,
            ragSociale: cooperativa.ragSociale,
            userAggiornamento: 'batch',
            isCooperativaNew: isCooperativaNew
        }
        return this.http.post(uri, body, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getAziendeAssociateCooperativa(idCooperativa) {
        let uri = `${environment.apiEndPoint}getAziendeAssociateCooperativa?idCooperativa=` + idCooperativa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    annullaAssociazioneAziendaCooperativa(idCooperativaAzienda) {
        let uri = `${environment.apiEndPoint}annullaAssociazioneAziendaCooperativa?idCooperativaAzienda=` + idCooperativaAzienda;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getAziendeAssociateConsorzio(cuaaCa, idCooperativa) {
        let uri = `${environment.apiEndPoint}getAziendeAssociateConsorzio?cuaaCa=` + cuaaCa + "&idCooperativa=" + idCooperativa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    associaAziendaACooperativa(aziendaCooperativa) {
        let body = {
            prodFili: null,
            cuaa: aziendaCooperativa.cuaa,
            idCooperativa: aziendaCooperativa.idCooperativa,
            ragSociale: aziendaCooperativa.ragSociale,
            cuaaCa: null,
            userAggiornamento: aziendaCooperativa.userAggiornamento,
            isCooperativaNew: null
        }
        let uri = `${environment.apiEndPoint}associaAziendaACooperativa`;
        return this.http.post(uri, body, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    getDescLuogo(codBelfiore) {
        let uri = `${environment.apiEndPoint}getDescLuogo?codBelfiore=` + codBelfiore;
        return this.http.get(uri, { observe: 'response', responseType: 'text' }).pipe(
            catchError(this.onError)
        );
    }

    getDatiAziendaCensita(idAziendeUser, cuaa) {
        let uri = `${environment.apiEndPoint}getDatiAziendaCensita?idAziendeUser=` + idAziendeUser + "&cuaa=" + cuaa;
        return this.http.get(uri, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    inserisciFiliera(filiera) {
        let uri = `${environment.apiEndPoint}inserisciFiliera`;
        let body = filiera
        return this.http.post(uri, body, { observe: 'response' }).pipe(
            catchError(this.onError)
        );
    }

    onError(err) {
        var errore = sessionStorage.getItem('errore')
        if (errore) {
            sessionStorage.removeItem('errore');
            return throwError(errore);
        }
        if (err.url.includes('visualizzaConsensi')) {
            return throwError(err);
        }
        return throwError("Errore server side");
    }
}
